<template>
  <v-card
    class="game-card my-3 rounded"
    :class="{ 'disabled': disabled }"
    elevation="6"
    @click="goToGame"
  >
    <v-card-title>
      {{ title }}
    </v-card-title>

    <v-card-subtitle>
      {{ description }}
    </v-card-subtitle>

    <div class="actions d-flex pl-4 align-center">
      <v-row class="d-flex justify-left">
        <v-col cols="6">
        <v-btn
          color="primary my-4"
          rounded
          large
          block
          depressed
        >
          {{ $t('GAME.PLAY') }}
        </v-btn>
        </v-col>
        <span class="high-score">
          <!-- {{ $t('GAME.HIGH_SCORE') }} 22/24 -->
        </span>
      </v-row>

      <v-avatar
        class="image-corner"
        size="150"
        tile
      >
        <v-img :src="$imageUrl(avatar, 'game-avatars/')" />
      </v-avatar>
    </div>
  </v-card>
</template>

<style scoped>
  .v-card:hover {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.16) !important;
    transition: all .2s;
  }
  .v-btn {
    text-transform: none;
  }
  .elevation-6 {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06) !important;
  }
  .disabled {
    filter: grayscale();
    opacity: .5;
  }
</style>

<style scoped lang="scss">
  .game-card .v-card__title {
    font-weight: 700;
    font-size: 24px;
  }

  .game-card .v-card__subtitle {
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.6rem;
  }

  .game-card .actions {
    margin-top: -32px;
  }
    .game-card .actions .v-btn {
      font-weight: 700;
    }

  .game-card .high-score {
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
  }

  .v-card.rounded {
    border-radius: $box-radius !important;
  }

  .v-card.rounded .image-corner {
    border-radius: 0px 0px $box-radius 0px !important;
  }
</style>

<script>
export default {
  name: 'GameCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: '',
    },
    avatar: {
      type: String,
      default: '',
    },
    route: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToGame(evt) {
      if (this.disabled) {
        return false;
      }

      if (this.isClassMode) {
        this.$track('play_game_class', 'home', this.route);
      } else {
        this.$track('play_game', 'home', this.route);
      }

      this.$emit('click', evt);
      return this.$router.push({ name: this.route });
    },
  },
};
</script>
